var staticStrUndefined = require('./staticStrUndefined')

/* eslint-disable valid-typeof */
var staticLocation = typeof location === staticStrUndefined ? 0 : location

module.exports = staticLocation



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticLocation.js
// module id = 81
// module chunks = 98